import { render, staticRenderFns } from "./ProductCategoryDashboard.vue?vue&type=template&id=47b79934&scoped=true"
import script from "./ProductCategoryDashboard.vue?vue&type=script&lang=js"
export * from "./ProductCategoryDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryDashboard.vue?vue&type=style&index=0&id=47b79934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b79934",
  null
  
)

export default component.exports